export default __webpack_public_path__ + "static/media/right-black.a62b4af7.svg";